import React, { useRef } from 'react';

import { ProjectDataContext } from './ProjectDataContext';

export const ProjectDataProvider = ({
    children
}: {
    children: React.ReactNode;
}) => {
    const refetchFn = useRef<() => Promise<void>>(async () => {
        // placeholder, replaced by setRefetchProjects
    });

    const setRefetchProjects = (refetch: () => Promise<void>) => {
        refetchFn.current = refetch;
    };

    const refetchProjects = async () => {
        await refetchFn.current();
    };

    return (
        <ProjectDataContext.Provider
            value={{
                refetchProjects,
                setRefetchProjects
            }}
        >
            {children}
        </ProjectDataContext.Provider>
    );
};
